import httpClient from "./httpClient";

const RoleService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/role", {
      params: { page, pageSize }
    });
  }
};

export default RoleService;
